/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Switch, Label, Pressable, Tooltip } from '@components/atoms'

import { useAppDispatch, useAppSelector, EditMenuType, adminActions } from '@redux/index'
import { produce } from 'immer'

interface PropsType {
	readOnly?: boolean
}

export const AdminEditMenuActivateToggle = (props: PropsType) => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const editTempMenu: EditMenuType = useAppSelector(state => state.admin.editTempMenu)

	// state
	const [isChecked, setIsChecked] = React.useState<boolean>(editTempMenu.isActivate)

	// variables
	const readOnly: boolean = props.readOnly ?? false

	React.useEffect(() => {
		setIsChecked(editTempMenu.isActivate)
	}, [editTempMenu.isActivate])

	const onSwitchClick = React.useCallback(() => {
		if (editTempMenu.id !== '') {
			const newIsActivate = !isChecked

			const newMenu: EditMenuType = produce(editTempMenu, draft => {
				draft.isActivate = newIsActivate
			})

			reduxDispatch(adminActions.EDIT_TEMP_MENU({ ...newMenu }))
		}
	}, [editTempMenu, isChecked])

	return (
		<View css={style}>
			<Label style={{}}>활성화</Label>
			<Tooltip
				title={
					editTempMenu.id === ''
						? ''
						: isChecked
						? "'활성화'는 메뉴에서 보여집니다."
						: "'비활성화'는 메뉴에서 보이지 않습니다."
				}
			>
				<Pressable onClick={onSwitchClick} disabled={readOnly}>
					<Switch
						checked={isChecked}
						inputProps={{ 'aria-label': 'controlled' }}
						disabled={editTempMenu.id === ''}
					/>
				</Pressable>
			</Tooltip>
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
})
